import { HttpContextToken } from '@angular/common/http';

/** Set on an individual request's HttpContext to opt it out of the automatic X-Brand-Id header. */
export const SKIP_BRAND_SCOPE = new HttpContextToken<boolean>(() => false);

// Endpoints that must never get an auto brand header: Users/Pages/Brands admin screens are
// inherently cross-brand, and config-management endpoints key by a Brand *name* string via
// their own (brand, platform, environment) picker, not Brand.id - they stay on that picker
// permanently rather than joining the shared brand context. Platform mappings are global -
// a platform's QuickPlay name is the same for every brand.
const BRAND_SCOPE_EXCLUDED_PATTERNS = ['/User/', '/Page/', '/Brand/', '/ApiAccess/', 'Management', 'VodPlaylistConfigurations', '/PlatformMapping/'];

export function isBrandScopeExcluded(url: string): boolean {
  return BRAND_SCOPE_EXCLUDED_PATTERNS.some(pattern => url.includes(pattern));
}
